import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { LoginContent } from "../loginContent.js";

/**
 * The sign-in page, showroom layout: the panel alone, centered in a narrow column with room above
 * it, as a modal sits over the page. On phones it spans the gutters.
 */
export function LoginShowroomLayout({ sections }: PageLayoutProps<LoginContent>) {
  return (
    <Section className="flex justify-center pt-8 pb-20 md:pt-20 md:pb-28">
      <div className="w-full max-w-[440px]">{sections.panel}</div>
    </Section>
  );
}
